import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowRightDoubleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { cx } from "shared/utils";
import { ActivePage } from "../store";

export const PageCard = ({
  label,
  icon,
  page,
  activePage,
  onClick
}: {
  label: string;
  icon: typeof ArrowRightDoubleIcon;
  page: ActivePage;
  activePage: ActivePage;
  onClick: () => void;
}) => (
  <button
    type="button"
    className="border border-alpha-100 bg-white rounded-md shadow-sm h-[52px] px-4 py-2 flex items-center gap-2 select-none cursor-pointer w-full text-left"
    onClick={onClick}
  >
    <div className="px-3 py-1.5 border border-alpha-100 rounded-md shrink-0">
      <HugeiconsIcon
        icon={icon}
        size={20}
        strokeWidth={1.5}
        className="text-content-1000"
      />
    </div>
    <p
      className={cx(
        "truncate text-sm transition-all",
        activePage === page
          ? "text-content-1000 font-bold"
          : "text-content-300 font-medium"
      )}
    >
      {label}
    </p>
  </button>
);
